// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1ilxT","title":"ClientReferral_title__1NBTG","itemText":"ClientReferral_itemText__1wC-_"};